

// //client/src/pages/payment/PaymentHomePage.jsx
// import React from "react";
// import { useNavigate } from "react-router-dom";

// export default function PaymentHomePage() {

//   const navigate =
//     useNavigate();

//   return (

//     <div className="page-wrap">

//       <header className="topbar">

//         <div className="brand">

//           <span className="logo">
//             💰
//           </span>

//           <div>

//             <div className="title">
//               Payment Management
//             </div>

//             <div className="subtitle">
//               Manage Payment Operations
//             </div>

//           </div>

//         </div>

//       </header>

//       <main
//         className="center"
//         style={{
//           paddingTop: "90px",
//         }}
//       >

//         <div
//           style={{
//             width: "100%",
//             maxWidth: "900px",
//             display: "grid",
//             gridTemplateColumns:
//               "repeat(2,1fr)",
//             gap: "25px",
//           }}
//         >

//           {/* UPLOAD */}

//           <div
//             className="card"
//             style={{
//               cursor: "pointer",
//               minHeight: "220px",
//             }}
//             onClick={() =>
//               navigate(
//                 "/payment/upload"
//               )
//             }
//           >

//             <h2>
//               Upload Payments
//             </h2>

//             <p
//               style={{
//                 marginTop: "15px",
//               }}
//             >
//               Upload payment Excel
//               sheets and reconcile
//               invoices automatically.
//             </p>

//           </div>

//           {/* EDIT */}

//           <div
//             className="card"
//             style={{
//               cursor: "pointer",
//               minHeight: "220px",
//             }}
//             onClick={() =>
//               navigate(
//                 "/payment/records"
//               )
//             }
//           >

//             <h2>
//               Edit Payments
//             </h2>

//             <p
//               style={{
//                 marginTop: "15px",
//               }}
//             >
//               Search invoices,
//               update payment
//               references and
//               manage payment
//               records.
//             </p>

//           </div>

//         </div>

//       </main>

//     </div>
//   );
// }


// // client/src/pages/payment/PaymentHomePage.jsx

// import React from "react";
// import { useNavigate } from "react-router-dom";

// export default function PaymentHomePage() {

//   const navigate = useNavigate();

//   return (

//     <div className="page-wrap">

//       {/* HEADER */}

//       <header className="topbar">

//         <div className="brand">

//           <span className="logo">💰</span>

//           <div>

//             <div className="title">Payment Management</div>

//             <div className="subtitle">Manage Payment Operations</div>

//           </div>

//         </div>

//       </header>

//       {/* MAIN */}

//       <main
//         style={{
//           paddingTop: "80px",
//           paddingBottom: "60px",
//           paddingLeft: "32px",
//           paddingRight: "32px",
//           maxWidth: "1400px",
//           margin: "0 auto",
//         }}
//       >

//         {/* PAGE TITLE */}

//         <div style={styles.pageHeader}>

//           <h1 style={styles.pageTitle}>Payment Operations</h1>

//           <p style={styles.pageSubtitle}>
//             Select an operation to get started
//           </p>

//         </div>

//         {/* CARDS GRID */}

//         <div style={styles.grid}>

//           {/* UPLOAD CARD */}

//           <div
//             style={styles.card}
//             onClick={() => navigate("/payment/upload")}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.borderColor = "#6366f1";
//               e.currentTarget.style.boxShadow =
//                 "0 4px 20px rgba(99,102,241,0.10)";
//               e.currentTarget.style.transform = "translateY(-2px)";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.borderColor = "#e5e7eb";
//               e.currentTarget.style.boxShadow = "none";
//               e.currentTarget.style.transform = "translateY(0)";
//             }}
//           >

//             {/* ICON */}

//             <div style={{ ...styles.iconWrap, backgroundColor: "#eff6ff" }}>
//               <span style={styles.icon}>📤</span>
//             </div>

//             {/* CONTENT */}

//             <div style={styles.cardContent}>

//               <div style={styles.cardTop}>

//                 <h2 style={styles.cardTitle}>Upload Payments</h2>

//                 <span style={{ ...styles.badge, backgroundColor: "#eff6ff", color: "#1d4ed8" }}>
//                   Excel
//                 </span>

//               </div>

//               <p style={styles.cardDesc}>
//                 Upload payment Excel sheets and reconcile invoices automatically.
//                 Matches records by invoice number and updates payment status in bulk.
//               </p>

//               <div style={styles.cardFooter}>

//                 <div style={styles.metaList}>

//                   <span style={styles.metaItem}>
//                     <span style={styles.metaDot} />
//                     Bulk reconciliation
//                   </span>

//                   <span style={styles.metaItem}>
//                     <span style={styles.metaDot} />
//                     Auto status update
//                   </span>

//                   <span style={styles.metaItem}>
//                     <span style={styles.metaDot} />
//                     Mismatch detection
//                   </span>

//                 </div>

//                 <div style={styles.action}>
//                   Upload
//                   <span style={styles.arrow}>→</span>
//                 </div>

//               </div>

//             </div>

//           </div>

//           {/* RECORDS CARD */}

//           <div
//             style={styles.card}
//             onClick={() => navigate("/payment/records")}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.borderColor = "#6366f1";
//               e.currentTarget.style.boxShadow =
//                 "0 4px 20px rgba(99,102,241,0.10)";
//               e.currentTarget.style.transform = "translateY(-2px)";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.borderColor = "#e5e7eb";
//               e.currentTarget.style.boxShadow = "none";
//               e.currentTarget.style.transform = "translateY(0)";
//             }}
//           >

//             {/* ICON */}

//             <div style={{ ...styles.iconWrap, backgroundColor: "#f5f3ff" }}>
//               <span style={styles.icon}>🗂️</span>
//             </div>

//             {/* CONTENT */}

//             <div style={styles.cardContent}>

//               <div style={styles.cardTop}>

//                 <h2 style={styles.cardTitle}>Payment Records</h2>

//                 <span style={{ ...styles.badge, backgroundColor: "#f5f3ff", color: "#7c3aed" }}>
//                   Search
//                 </span>

//               </div>

//               <p style={styles.cardDesc}>
//                 Search invoices by vendor, quarter, or status. Update payment
//                 references, dates, and manage individual payment records.
//               </p>

//               <div style={styles.cardFooter}>

//                 <div style={styles.metaList}>

//                   <span style={styles.metaItem}>
//                     <span style={styles.metaDot} />
//                     Filter by vendor
//                   </span>

//                   <span style={styles.metaItem}>
//                     <span style={styles.metaDot} />
//                     Filter by quarter
//                   </span>

//                   <span style={styles.metaItem}>
//                     <span style={styles.metaDot} />
//                     Inline edit
//                   </span>

//                 </div>

//                 <div style={styles.action}>
//                   Open Records
//                   <span style={styles.arrow}>→</span>
//                 </div>

//               </div>

//             </div>

//           </div>

//         </div>

//       </main>

//     </div>
//   );
// }

// // ─────────────────────────────────────
// // STYLES
// // ─────────────────────────────────────
// const styles = {

//   pageHeader: {
//     marginBottom: "28px",
//   },

//   pageTitle: {
//     fontSize: "18px",
//     fontWeight: "700",
//     color: "#111827",
//     margin: 0,
//     letterSpacing: "-0.01em",
//   },

//   pageSubtitle: {
//     fontSize: "13px",
//     color: "#6b7280",
//     marginTop: "4px",
//     fontWeight: "400",
//   },

//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(2, 1fr)",
//     gap: "20px",
//     maxWidth: "900px",
//   },

//   card: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "20px",
//     padding: "24px",
//     backgroundColor: "#ffffff",
//     border: "1px solid #e5e7eb",
//     borderRadius: "10px",
//     cursor: "pointer",
//     transition: "border-color 0.15s, box-shadow 0.15s, transform 0.15s",
//   },

//   iconWrap: {
//     width: "44px",
//     height: "44px",
//     borderRadius: "10px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },

//   icon: {
//     fontSize: "20px",
//   },

//   cardContent: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "12px",
//     flex: 1,
//   },

//   cardTop: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     gap: "12px",
//   },

//   cardTitle: {
//     fontSize: "15px",
//     fontWeight: "700",
//     color: "#111827",
//     margin: 0,
//     letterSpacing: "-0.01em",
//   },

//   badge: {
//     display: "inline-block",
//     padding: "2px 8px",
//     borderRadius: "4px",
//     fontSize: "11px",
//     fontWeight: "600",
//     letterSpacing: "0.02em",
//   },

//   cardDesc: {
//     fontSize: "13px",
//     color: "#6b7280",
//     lineHeight: "1.6",
//     margin: 0,
//     fontWeight: "400",
//   },

//   cardFooter: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginTop: "4px",
//     paddingTop: "16px",
//     borderTop: "1px solid #f3f4f6",
//   },

//   metaList: {
//     display: "flex",
//     gap: "14px",
//     flexWrap: "wrap",
//   },

//   metaItem: {
//     display: "flex",
//     alignItems: "center",
//     gap: "5px",
//     fontSize: "11px",
//     color: "#9ca3af",
//     fontWeight: "500",
//   },

//   metaDot: {
//     width: "4px",
//     height: "4px",
//     borderRadius: "50%",
//     backgroundColor: "#d1d5db",
//     display: "inline-block",
//   },

//   action: {
//     display: "flex",
//     alignItems: "center",
//     gap: "4px",
//     fontSize: "12px",
//     fontWeight: "600",
//     color: "#6366f1",
//     whiteSpace: "nowrap",
//   },

//   arrow: {
//     fontSize: "14px",
//     transition: "transform 0.15s",
//   },

// };



// // client/src/pages/payment/PaymentHomePage.jsx

// import React from "react";
// import { useNavigate } from "react-router-dom";

// export default function PaymentHomePage() {

//   const navigate = useNavigate();

//   return (

//     <div className="page-wrap">

//       {/* HEADER */}

//       <header className="topbar">

//         <div className="brand">

//           <span className="logo">💰</span>

//           <div>

//             <div className="title">Payment Management</div>

//             <div className="subtitle">Manage Payment Operations</div>

//           </div>

//         </div>

//       </header>

//       {/* MAIN */}

//       <main
//         style={{
//           paddingTop: "80px",
//           paddingBottom: "60px",
//           paddingLeft: "40px",
//           paddingRight: "40px",
//           maxWidth: "1400px",
//           margin: "0 auto",
//           boxSizing: "border-box",
//           width: "100%",
//         }}
//       >

//         {/* PAGE TITLE */}

//         <div style={styles.pageHeader}>

//           <h1 style={styles.pageTitle}>Payment Operations</h1>

//           <p style={styles.pageSubtitle}>
//             Select an operation to get started
//           </p>

//         </div>

//         {/* CARDS GRID */}

//         <div style={styles.grid}>

//           {/* UPLOAD CARD */}

//           <div
//             style={styles.card}
//             onClick={() => navigate("/payment/upload")}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.borderColor = "#6366f1";
//               e.currentTarget.style.boxShadow =
//                 "0 4px 24px rgba(99,102,241,0.10)";
//               e.currentTarget.style.transform = "translateY(-2px)";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.borderColor = "#e5e7eb";
//               e.currentTarget.style.boxShadow = "none";
//               e.currentTarget.style.transform = "translateY(0)";
//             }}
//           >

//             {/* TOP ROW */}

//             <div style={styles.cardTopRow}>

//               <div style={{ ...styles.iconWrap, backgroundColor: "#eff6ff" }}>
//                 <span style={styles.icon}>📤</span>
//               </div>

//               <span style={{
//                 ...styles.badge,
//                 backgroundColor: "#eff6ff",
//                 color: "#1d4ed8",
//               }}>
//                 Excel Upload
//               </span>

//             </div>

//             {/* TITLE */}

//             <h2 style={styles.cardTitle}>Upload Payments</h2>

//             {/* DESC */}

//             <p style={styles.cardDesc}>
//               Upload payment Excel sheets to process and update invoice payment
//               records in the database. Each row is matched by invoice number
//               and payment details are saved automatically.
//             </p>

//             {/* FEATURES */}

//             <div style={styles.featureList}>

//               <div style={styles.featureItem}>
//                 <span style={styles.featureDot} />
//                 <span>Bulk processing</span>
//               </div>

//               <div style={styles.featureItem}>
//                 <span style={styles.featureDot} />
//                 <span>Auto status update</span>
//               </div>

//               <div style={styles.featureItem}>
//                 <span style={styles.featureDot} />
//                 <span>Mismatch detection</span>
//               </div>

//               <div style={styles.featureItem}>
//                 <span style={styles.featureDot} />
//                 <span>Duplicate check</span>
//               </div>

//             </div>

//             {/* FOOTER */}

//             <div style={styles.cardFooter}>

//               <span style={styles.footerHint}>
//                 Supports .xlsx and .xls formats
//               </span>

//               <div style={{ ...styles.action, color: "#1d4ed8" }}>
//                 Go to Upload
//                 <span style={styles.arrow}>→</span>
//               </div>

//             </div>

//           </div>

//           {/* RECORDS CARD */}

//           <div
//             style={styles.card}
//             onClick={() => navigate("/payment/records")}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.borderColor = "#6366f1";
//               e.currentTarget.style.boxShadow =
//                 "0 4px 24px rgba(99,102,241,0.10)";
//               e.currentTarget.style.transform = "translateY(-2px)";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.borderColor = "#e5e7eb";
//               e.currentTarget.style.boxShadow = "none";
//               e.currentTarget.style.transform = "translateY(0)";
//             }}
//           >

//             {/* TOP ROW */}

//             <div style={styles.cardTopRow}>

//               <div style={{ ...styles.iconWrap, backgroundColor: "#f5f3ff" }}>
//                 <span style={styles.icon}>🗂️</span>
//               </div>

//               <span style={{
//                 ...styles.badge,
//                 backgroundColor: "#f5f3ff",
//                 color: "#7c3aed",
//               }}>
//                 Search & Edit
//               </span>

//             </div>

//             {/* TITLE */}

//             <h2 style={styles.cardTitle}>Payment Records</h2>

//             {/* DESC */}

//             <p style={styles.cardDesc}>
//               Search and manage existing invoice payment records. Filter by
//               vendor, billing quarter, or payment status. Edit payment dates,
//               amounts, and reference numbers on individual invoices.
//             </p>

//             {/* FEATURES */}

//             <div style={styles.featureList}>

//               <div style={styles.featureItem}>
//                 <span style={styles.featureDot} />
//                 <span>Filter by vendor</span>
//               </div>

//               <div style={styles.featureItem}>
//                 <span style={styles.featureDot} />
//                 <span>Filter by quarter</span>
//               </div>

//               <div style={styles.featureItem}>
//                 <span style={styles.featureDot} />
//                 <span>Filter by status</span>
//               </div>

//               <div style={styles.featureItem}>
//                 <span style={styles.featureDot} />
//                 <span>Inline edit</span>
//               </div>

//             </div>

//             {/* FOOTER */}

//             <div style={styles.cardFooter}>

//               <span style={styles.footerHint}>
//                 Supports partial invoice number search
//               </span>

//               <div style={{ ...styles.action, color: "#7c3aed" }}>
//                 Open Records
//                 <span style={styles.arrow}>→</span>
//               </div>

//             </div>

//           </div>

//         </div>

//       </main>

//     </div>
//   );
// }

// // ─────────────────────────────────────
// // STYLES
// // ─────────────────────────────────────
// const styles = {

//   pageHeader: {
//     marginBottom: "32px",
//   },

//   pageTitle: {
//     fontSize: "18px",
//     fontWeight: "700",
//     color: "#111827",
//     margin: 0,
//     letterSpacing: "-0.01em",
//   },

//   pageSubtitle: {
//     fontSize: "13px",
//     color: "#6b7280",
//     marginTop: "4px",
//     margin: "4px 0 0 0",
//     fontWeight: "400",
//   },

//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(2, 1fr)",
//     gap: "24px",
//     width: "100%",
//   },

//   card: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "18px",
//     padding: "28px 28px 24px 28px",
//     backgroundColor: "#ffffff",
//     border: "1px solid #e5e7eb",
//     borderRadius: "10px",
//     cursor: "pointer",
//     transition: "border-color 0.15s, box-shadow 0.15s, transform 0.15s",
//     boxSizing: "border-box",
//   },

//   cardTopRow: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//   },

//   iconWrap: {
//     width: "44px",
//     height: "44px",
//     borderRadius: "10px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     flexShrink: 0,
//   },

//   icon: {
//     fontSize: "20px",
//   },

//   badge: {
//     display: "inline-block",
//     padding: "3px 10px",
//     borderRadius: "4px",
//     fontSize: "11px",
//     fontWeight: "600",
//     letterSpacing: "0.02em",
//   },

//   cardTitle: {
//     fontSize: "16px",
//     fontWeight: "700",
//     color: "#111827",
//     margin: 0,
//     letterSpacing: "-0.01em",
//   },

//   cardDesc: {
//     fontSize: "13px",
//     color: "#6b7280",
//     lineHeight: "1.65",
//     margin: 0,
//     fontWeight: "400",
//   },

//   featureList: {
//     display: "grid",
//     gridTemplateColumns: "1fr 1fr",
//     gap: "8px 16px",
//   },

//   featureItem: {
//     display: "flex",
//     alignItems: "center",
//     gap: "6px",
//     fontSize: "12px",
//     color: "#9ca3af",
//     fontWeight: "500",
//   },

//   featureDot: {
//     width: "4px",
//     height: "4px",
//     borderRadius: "50%",
//     backgroundColor: "#d1d5db",
//     flexShrink: 0,
//   },

//   cardFooter: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     paddingTop: "18px",
//     borderTop: "1px solid #f3f4f6",
//     marginTop: "auto",
//   },

//   footerHint: {
//     fontSize: "11px",
//     color: "#d1d5db",
//     fontWeight: "400",
//   },

//   action: {
//     display: "flex",
//     alignItems: "center",
//     gap: "5px",
//     fontSize: "12px",
//     fontWeight: "700",
//     whiteSpace: "nowrap",
//   },

//   arrow: {
//     fontSize: "14px",
//   },

// };


// // client/src/pages/payment/PaymentHomePage.jsx

// import React from "react";
// import { useNavigate } from "react-router-dom";

// export default function PaymentHomePage() {
//   const navigate = useNavigate();

//   return (
//     <div className="page-wrap">
//       {/* HEADER */}
//       <header className="topbar">
//         <div className="brand">
//           <span className="logo">💰</span>
//           <div>
//             <div className="title">Payment Management</div>
//             <div className="subtitle">Manage Payment Operations</div>
//           </div>
//         </div>
//       </header>

//       {/* MAIN */}
//       <main
//         style={{
//           paddingTop: "80px",
//           paddingBottom: "60px",
//           paddingLeft: "40px",
//           paddingRight: "40px",
//           maxWidth: "1400px",
//           margin: "0 auto",
//           boxSizing: "border-box",
//           width: "100%",
//         }}
//       >
//         {/* PAGE HEADER */}
//         <div style={styles.pageHeader}>
//           <div style={styles.eyebrowRow}>
//             <span style={styles.eyebrowDot} />
//             <span style={styles.eyebrow}>Workspace</span>
//             <span style={styles.eyebrowSep}>/</span>
//             <span style={styles.eyebrowMuted}>Payments</span>
//           </div>
//           <h1 style={styles.pageTitle}>Payment Operations</h1>
//           <p style={styles.pageSubtitle}>
//             Upload, process and manage invoice payments from a single workspace.
//           </p>
//         </div>

//         {/* STATUS STRIP */}
//         <div style={styles.statusStrip}>
//           <div style={styles.statusItem}>
//             <div style={styles.statusLabel}>System</div>
//             <div style={styles.statusValueRow}>
//               <span style={{ ...styles.pulseDot, backgroundColor: "#10b981" }} />
//               <span style={styles.statusValue}>Operational</span>
//             </div>
//           </div>
//           <div style={styles.statusDivider} />
//           <div style={styles.statusItem}>
//             <div style={styles.statusLabel}>Last sync</div>
//             <div style={styles.statusValue}>Just now</div>
//           </div>
//           <div style={styles.statusDivider} />
//           <div style={styles.statusItem}>
//             <div style={styles.statusLabel}>Supported files</div>
//             <div style={styles.statusValue}>.xlsx · .xls</div>
//           </div>
//           <div style={styles.statusDivider} />
//           <div style={styles.statusItem}>
//             <div style={styles.statusLabel}>Mode</div>
//             <div style={styles.statusValue}>Bulk processing</div>
//           </div>
//         </div>

//         {/* SECTION LABEL */}
//         <div style={styles.sectionLabelRow}>
//           <span style={styles.sectionLabel}>Quick actions</span>
//           <span style={styles.sectionHint}>Select an operation to continue</span>
//         </div>

//         {/* CARDS GRID */}
//         <div style={styles.grid}>
//           {/* UPLOAD CARD */}
//           <div
//             style={styles.card}
//             onClick={() => navigate("/payment/upload")}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.borderColor = "#c7d2fe";
//               e.currentTarget.style.boxShadow =
//                 "0 4px 24px rgba(99,102,241,0.10)";
//               e.currentTarget.style.transform = "translateY(-2px)";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.borderColor = "#e5e7eb";
//               e.currentTarget.style.boxShadow = "none";
//               e.currentTarget.style.transform = "translateY(0)";
//             }}
//           >
//             {/* ACCENT BAR */}
//             <div
//               style={{
//                 ...styles.accentBar,
//                 background: "linear-gradient(90deg, #2563eb 0%, #60a5fa 100%)",
//               }}
//             />

//             {/* TOP ROW */}
//             <div style={styles.cardTopRow}>
//               <div style={{ ...styles.iconWrap, backgroundColor: "#eff6ff" }}>
//                 <span style={styles.icon}>📤</span>
//               </div>
//               <span
//                 style={{
//                   ...styles.badge,
//                   backgroundColor: "#eff6ff",
//                   color: "#1d4ed8",
//                 }}
//               >
//                 Excel Upload
//               </span>
//             </div>

//             {/* TITLE BLOCK */}
//             <div>
//               <div style={styles.cardKicker}>Ingest</div>
//               <h2 style={styles.cardTitle}>Upload Payments</h2>
//               <p style={styles.cardDesc}>
//                 Upload payment Excel sheets to process and update invoice
//                 payment records in the database. Each row is matched by invoice
//                 number and payment details are saved automatically.
//               </p>
//             </div>

//             {/* FEATURES */}
//             <div style={styles.featureList}>
//               <Feature label="Bulk processing" />
//               <Feature label="Auto status update" />
//               <Feature label="Mismatch detection" />
//               <Feature label="Duplicate check" />
//             </div>

//             {/* FOOTER */}
//             <div style={styles.cardFooter}>
//               <span style={styles.footerHint}>
//                 Supports .xlsx and .xls formats
//               </span>
//               <div style={{ ...styles.action, color: "#1d4ed8" }}>
//                 Go to Upload
//                 <span style={styles.arrow}>→</span>
//               </div>
//             </div>
//           </div>

//           {/* RECORDS CARD */}
//           <div
//             style={styles.card}
//             onClick={() => navigate("/payment/records")}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.borderColor = "#ddd6fe";
//               e.currentTarget.style.boxShadow =
//                 "0 4px 24px rgba(99,102,241,0.10)";
//               e.currentTarget.style.transform = "translateY(-2px)";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.borderColor = "#e5e7eb";
//               e.currentTarget.style.boxShadow = "none";
//               e.currentTarget.style.transform = "translateY(0)";
//             }}
//           >
//             {/* ACCENT BAR */}
//             <div
//               style={{
//                 ...styles.accentBar,
//                 background: "linear-gradient(90deg, #7c3aed 0%, #a78bfa 100%)",
//               }}
//             />

//             {/* TOP ROW */}
//             <div style={styles.cardTopRow}>
//               <div style={{ ...styles.iconWrap, backgroundColor: "#f5f3ff" }}>
//                 <span style={styles.icon}>🗂️</span>
//               </div>
//               <span
//                 style={{
//                   ...styles.badge,
//                   backgroundColor: "#f5f3ff",
//                   color: "#7c3aed",
//                 }}
//               >
//                 Search & Edit
//               </span>
//             </div>

//             {/* TITLE BLOCK */}
//             <div>
//               <div style={styles.cardKicker}>Manage</div>
//               <h2 style={styles.cardTitle}>Payment Records</h2>
//               <p style={styles.cardDesc}>
//                 Search and manage existing invoice payment records. Filter by
//                 vendor, billing quarter, or payment status. Edit payment dates,
//                 amounts, and reference numbers on individual invoices.
//               </p>
//             </div>

//             {/* FEATURES */}
//             <div style={styles.featureList}>
//               <Feature label="Filter by vendor" />
//               <Feature label="Filter by quarter" />
//               <Feature label="Filter by status" />
//               <Feature label="Inline edit" />
//             </div>

//             {/* FOOTER */}
//             <div style={styles.cardFooter}>
//               <span style={styles.footerHint}>
//                 Supports partial invoice number search
//               </span>
//               <div style={{ ...styles.action, color: "#7c3aed" }}>
//                 Open Records
//                 <span style={styles.arrow}>→</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// }

// // ─────────────────────────────────────
// // SMALL COMPONENTS
// // ─────────────────────────────────────
// function Feature({ label }) {
//   return (
//     <div style={styles.featureItem}>
//       <span style={styles.featureCheck}>✓</span>
//       <span>{label}</span>
//     </div>
//   );
// }

// // ─────────────────────────────────────
// // STYLES
// // ─────────────────────────────────────
// const styles = {

//   pageHeader: {
//     marginBottom: "28px",
//   },

//   eyebrowRow: {
//     display: "flex",
//     alignItems: "center",
//     gap: "7px",
//     marginBottom: "10px",
//   },

//   eyebrowDot: {
//     width: "6px",
//     height: "6px",
//     borderRadius: "50%",
//     backgroundColor: "#6366f1",
//     boxShadow: "0 0 0 3px rgba(99,102,241,0.15)",
//   },

//   eyebrow: {
//     fontSize: "11px",
//     fontWeight: "700",
//     color: "#4f46e5",
//     letterSpacing: "0.07em",
//     textTransform: "uppercase",
//   },

//   eyebrowSep: {
//     fontSize: "11px",
//     color: "#d1d5db",
//   },

//   eyebrowMuted: {
//     fontSize: "11px",
//     fontWeight: "600",
//     color: "#9ca3af",
//     letterSpacing: "0.07em",
//     textTransform: "uppercase",
//   },

//   pageTitle: {
//     fontSize: "18px",
//     fontWeight: "700",
//     color: "#111827",
//     margin: 0,
//     letterSpacing: "-0.01em",
//   },

//   pageSubtitle: {
//     fontSize: "13px",
//     color: "#6b7280",
//     marginTop: "4px",
//     margin: "4px 0 0 0",
//     fontWeight: "400",
//     maxWidth: "520px",
//     lineHeight: "1.6",
//   },

//   statusStrip: {
//     display: "flex",
//     alignItems: "stretch",
//     padding: "13px 18px",
//     backgroundColor: "#ffffff",
//     border: "1px solid #e5e7eb",
//     borderRadius: "10px",
//     marginBottom: "28px",
//     boxShadow: "0 1px 2px rgba(15,23,42,0.03)",
//   },

//   statusItem: {
//     flex: 1,
//     display: "flex",
//     flexDirection: "column",
//     gap: "4px",
//     padding: "2px 10px",
//   },

//   statusLabel: {
//     fontSize: "10px",
//     fontWeight: "600",
//     color: "#9ca3af",
//     letterSpacing: "0.07em",
//     textTransform: "uppercase",
//   },

//   statusValueRow: {
//     display: "flex",
//     alignItems: "center",
//     gap: "6px",
//   },

//   statusValue: {
//     fontSize: "13px",
//     fontWeight: "600",
//     color: "#111827",
//   },

//   pulseDot: {
//     width: "7px",
//     height: "7px",
//     borderRadius: "50%",
//     boxShadow: "0 0 0 3px rgba(16,185,129,0.18)",
//   },

//   statusDivider: {
//     width: "1px",
//     backgroundColor: "#f1f5f9",
//     margin: "4px 0",
//   },

//   sectionLabelRow: {
//     display: "flex",
//     alignItems: "baseline",
//     justifyContent: "space-between",
//     marginBottom: "14px",
//   },

//   sectionLabel: {
//     fontSize: "11px",
//     fontWeight: "700",
//     color: "#374151",
//     letterSpacing: "0.07em",
//     textTransform: "uppercase",
//   },

//   sectionHint: {
//     fontSize: "12px",
//     color: "#9ca3af",
//     fontWeight: "400",
//   },

//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(2, 1fr)",
//     gap: "24px",
//     width: "100%",
//   },

//   card: {
//     position: "relative",
//     display: "flex",
//     flexDirection: "column",
//     gap: "18px",
//     padding: "28px 28px 24px 28px",
//     backgroundColor: "#ffffff",
//     border: "1px solid #e5e7eb",
//     borderRadius: "10px",
//     cursor: "pointer",
//     transition: "border-color 0.15s, box-shadow 0.15s, transform 0.15s",
//     boxSizing: "border-box",
//     overflow: "hidden",
//   },

//   accentBar: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     right: 0,
//     height: "3px",
//   },

//   cardTopRow: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginTop: "4px",
//   },

//   iconWrap: {
//     width: "44px",
//     height: "44px",
//     borderRadius: "10px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     flexShrink: 0,
//   },

//   icon: {
//     fontSize: "20px",
//   },

//   badge: {
//     display: "inline-block",
//     padding: "3px 10px",
//     borderRadius: "4px",
//     fontSize: "11px",
//     fontWeight: "600",
//     letterSpacing: "0.02em",
//   },

//   cardKicker: {
//     fontSize: "10px",
//     fontWeight: "700",
//     color: "#9ca3af",
//     letterSpacing: "0.1em",
//     textTransform: "uppercase",
//     marginBottom: "5px",
//   },

//   cardTitle: {
//     fontSize: "16px",
//     fontWeight: "700",
//     color: "#111827",
//     margin: 0,
//     letterSpacing: "-0.01em",
//   },

//   cardDesc: {
//     fontSize: "13px",
//     color: "#6b7280",
//     lineHeight: "1.65",
//     margin: "6px 0 0 0",
//     fontWeight: "400",
//   },

//   featureList: {
//     display: "grid",
//     gridTemplateColumns: "1fr 1fr",
//     gap: "8px 14px",
//     padding: "13px",
//     backgroundColor: "#fafafa",
//     borderRadius: "8px",
//     border: "1px solid #f3f4f6",
//   },

//   featureItem: {
//     display: "flex",
//     alignItems: "center",
//     gap: "6px",
//     fontSize: "12px",
//     color: "#4b5563",
//     fontWeight: "500",
//   },

//   featureCheck: {
//     width: "16px",
//     height: "16px",
//     borderRadius: "50%",
//     backgroundColor: "#ecfdf5",
//     color: "#059669",
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "10px",
//     fontWeight: "700",
//     flexShrink: 0,
//   },

//   cardFooter: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     paddingTop: "18px",
//     borderTop: "1px solid #f3f4f6",
//     marginTop: "auto",
//   },

//   footerHint: {
//     fontSize: "11px",
//     color: "#d1d5db",
//     fontWeight: "400",
//   },

//   action: {
//     display: "flex",
//     alignItems: "center",
//     gap: "5px",
//     fontSize: "12px",
//     fontWeight: "700",
//     whiteSpace: "nowrap",
//   },

//   arrow: {
//     fontSize: "14px",
//   },

// };


// client/src/pages/payment/PaymentHomePage.jsx

import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PaymentHomePage() {
  const navigate = useNavigate();

  const [hidden, setHidden] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const lastY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 8);
      if (y > lastY.current && y > 120) setHidden(true);
      else setHidden(false);
      lastY.current = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div style={styles.page}>

      {/* HEADER */}
      <header
        style={{
          ...styles.header,
          ...(scrolled ? styles.headerScrolled : {}),
          ...(hidden ? styles.headerHidden : {}),
        }}
      >
        <div style={styles.headerInner}>
          <div style={styles.brand}>
            <div style={styles.logoWrap}>💰</div>
            <div>
              <div style={styles.brandTitle}>Payment Management</div>
              <div style={styles.brandSubtitle}>Manage Payment Operations</div>
            </div>
          </div>
        </div>
      </header>

      {/* MAIN */}
      <main style={styles.main}>

        {/* PAGE HEADER */}
        <div style={styles.pageHeader}>
          <div style={styles.eyebrowRow}>
            <span style={styles.eyebrowDot} />
            <span style={styles.eyebrow}>Workspace</span>
            <span style={styles.eyebrowSep}>/</span>
            <span style={styles.eyebrowMuted}>Payments</span>
          </div>
          <h1 style={styles.pageTitle}>Payment Operations</h1>
          <p style={styles.pageSubtitle}>
            Upload, process and manage invoice payments from a single workspace.
          </p>
        </div>

        {/* STATUS STRIP */}
        <div style={styles.statusStrip}>
          <div style={styles.statusItem}>
            <div style={styles.statusLabel}>System</div>
            <div style={styles.statusValueRow}>
              <span style={{ ...styles.pulseDot, backgroundColor: "#10b981" }} />
              <span style={styles.statusValue}>Operational</span>
            </div>
          </div>
          <div style={styles.statusDivider} />
          <div style={styles.statusItem}>
            <div style={styles.statusLabel}>Last sync</div>
            <div style={styles.statusValue}>Just now</div>
          </div>
          <div style={styles.statusDivider} />
          <div style={styles.statusItem}>
            <div style={styles.statusLabel}>Supported files</div>
            <div style={styles.statusValue}>.xlsx · .xls</div>
          </div>
          <div style={styles.statusDivider} />
          <div style={styles.statusItem}>
            <div style={styles.statusLabel}>Mode</div>
            <div style={styles.statusValue}>Bulk processing</div>
          </div>
        </div>

        {/* SECTION LABEL */}
        <div style={styles.sectionLabelRow}>
          <span style={styles.sectionLabel}>Quick actions</span>
          <span style={styles.sectionHint}>Select an operation to continue</span>
        </div>

        {/* CARDS GRID */}
        <div style={styles.grid}>

          {/* UPLOAD CARD */}
          <div
            style={styles.card}
            onClick={() => navigate("/payment/upload")}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#c7d2fe";
              e.currentTarget.style.boxShadow = "0 4px 24px rgba(99,102,241,0.10)";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e7eb";
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <div style={{ ...styles.accentBar, background: "linear-gradient(90deg, #2563eb 0%, #60a5fa 100%)" }} />

            <div style={styles.cardTopRow}>
              <div style={{ ...styles.iconWrap, backgroundColor: "#eff6ff" }}>
                <span style={styles.icon}>📤</span>
              </div>
              <span style={{ ...styles.badge, backgroundColor: "#eff6ff", color: "#1d4ed8" }}>
                Excel Upload
              </span>
            </div>

            <div>
              <div style={styles.cardKicker}>Ingest</div>
              <h2 style={styles.cardTitle}>Upload Payments</h2>
              <p style={styles.cardDesc}>
                Upload payment Excel sheets to process and update invoice payment
                records in the database. Each row is matched by invoice number
                and payment details are saved automatically.
              </p>
            </div>

            <div style={styles.featureList}>
              <Feature label="Bulk processing" />
              <Feature label="Auto status update" />
              <Feature label="Mismatch detection" />
              <Feature label="Duplicate check" />
            </div>

            <div style={styles.cardFooter}>
              <span style={styles.footerHint}>Supports .xlsx and .xls formats</span>
              <div style={{ ...styles.action, color: "#1d4ed8" }}>
                Go to Upload
                <span style={styles.arrow}>→</span>
              </div>
            </div>
          </div>

          {/* RECORDS CARD */}
          <div
            style={styles.card}
            onClick={() => navigate("/payment/records")}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#ddd6fe";
              e.currentTarget.style.boxShadow = "0 4px 24px rgba(99,102,241,0.10)";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e7eb";
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <div style={{ ...styles.accentBar, background: "linear-gradient(90deg, #7c3aed 0%, #a78bfa 100%)" }} />

            <div style={styles.cardTopRow}>
              <div style={{ ...styles.iconWrap, backgroundColor: "#f5f3ff" }}>
                <span style={styles.icon}>🗂️</span>
              </div>
              <span style={{ ...styles.badge, backgroundColor: "#f5f3ff", color: "#7c3aed" }}>
                Search & Edit
              </span>
            </div>

            <div>
              <div style={styles.cardKicker}>Manage</div>
              <h2 style={styles.cardTitle}>Payment Records</h2>
              <p style={styles.cardDesc}>
                Search and manage existing invoice payment records. Filter by
                vendor, billing quarter, or payment status. Edit payment dates,
                amounts, and reference numbers on individual invoices.
              </p>
            </div>

            <div style={styles.featureList}>
              <Feature label="Filter by vendor" />
              <Feature label="Filter by quarter" />
              <Feature label="Filter by status" />
              <Feature label="Inline edit" />
            </div>

            <div style={styles.cardFooter}>
              <span style={styles.footerHint}>Supports partial invoice number search</span>
              <div style={{ ...styles.action, color: "#7c3aed" }}>
                Open Records
                <span style={styles.arrow}>→</span>
              </div>
            </div>
          </div>

        </div>
      </main>
    </div>
  );
}

// ─────────────────────────────────────
// SMALL COMPONENTS
// ─────────────────────────────────────
function Feature({ label }) {
  return (
    <div style={styles.featureItem}>
      <span style={styles.featureCheck}>✓</span>
      <span>{label}</span>
    </div>
  );
}

// ─────────────────────────────────────
// STYLES
// ─────────────────────────────────────
const styles = {

  page: {
    minHeight: "100vh",
    backgroundColor: "#f9fafb",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },

  // ── HEADER (matches HomePage exactly) ──
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: "56px",
    backgroundColor: "#0f172a",
    zIndex: 100,
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
    display: "flex",
    alignItems: "center",
  },

  headerScrolled: {
    boxShadow: "0 1px 0 rgba(255,255,255,0.06)",
  },

  headerHidden: {
    transform: "translateY(-100%)",
  },

  headerInner: {
    width: "100%",
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "0 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
  },

  brand: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  logoWrap: {
    fontSize: "20px",
    width: "36px",
    height: "36px",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  brandTitle: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#ffffff",
    letterSpacing: "-0.01em",
  },

  brandSubtitle: {
    fontSize: "11px",
    color: "rgba(255,255,255,0.45)",
    fontWeight: "400",
    marginTop: "1px",
  },

  // ── MAIN ──
  main: {
    paddingTop: "80px",
    paddingBottom: "60px",
    paddingLeft: "40px",
    paddingRight: "40px",
    maxWidth: "1400px",
    margin: "0 auto",
    boxSizing: "border-box",
    width: "100%",
  },

  pageHeader: {
    marginBottom: "28px",
  },

  eyebrowRow: {
    display: "flex",
    alignItems: "center",
    gap: "7px",
    marginBottom: "10px",
  },

  eyebrowDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: "#6366f1",
    boxShadow: "0 0 0 3px rgba(99,102,241,0.15)",
  },

  eyebrow: {
    fontSize: "11px",
    fontWeight: "700",
    color: "#4f46e5",
    letterSpacing: "0.07em",
    textTransform: "uppercase",
  },

  eyebrowSep: {
    fontSize: "11px",
    color: "#d1d5db",
  },

  eyebrowMuted: {
    fontSize: "11px",
    fontWeight: "600",
    color: "#9ca3af",
    letterSpacing: "0.07em",
    textTransform: "uppercase",
  },

  pageTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#111827",
    margin: 0,
    letterSpacing: "-0.01em",
  },

  pageSubtitle: {
    fontSize: "13px",
    color: "#6b7280",
    margin: "4px 0 0 0",
    fontWeight: "400",
    maxWidth: "520px",
    lineHeight: "1.6",
  },

  statusStrip: {
    display: "flex",
    alignItems: "stretch",
    padding: "13px 18px",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    marginBottom: "28px",
    boxShadow: "0 1px 2px rgba(15,23,42,0.03)",
  },

  statusItem: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: "2px 10px",
  },

  statusLabel: {
    fontSize: "10px",
    fontWeight: "600",
    color: "#9ca3af",
    letterSpacing: "0.07em",
    textTransform: "uppercase",
  },

  statusValueRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },

  statusValue: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#111827",
  },

  pulseDot: {
    width: "7px",
    height: "7px",
    borderRadius: "50%",
    boxShadow: "0 0 0 3px rgba(16,185,129,0.18)",
  },

  statusDivider: {
    width: "1px",
    backgroundColor: "#f1f5f9",
    margin: "4px 0",
  },

  sectionLabelRow: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    marginBottom: "14px",
  },

  sectionLabel: {
    fontSize: "11px",
    fontWeight: "700",
    color: "#374151",
    letterSpacing: "0.07em",
    textTransform: "uppercase",
  },

  sectionHint: {
    fontSize: "12px",
    color: "#9ca3af",
    fontWeight: "400",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "24px",
    width: "100%",
  },

  card: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: "18px",
    padding: "28px 28px 24px 28px",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "border-color 0.15s, box-shadow 0.15s, transform 0.15s",
    boxSizing: "border-box",
    overflow: "hidden",
  },

  accentBar: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "3px",
  },

  cardTopRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "4px",
  },

  iconWrap: {
    width: "44px",
    height: "44px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  icon: {
    fontSize: "20px",
  },

  badge: {
    display: "inline-block",
    padding: "3px 10px",
    borderRadius: "4px",
    fontSize: "11px",
    fontWeight: "600",
    letterSpacing: "0.02em",
  },

  cardKicker: {
    fontSize: "10px",
    fontWeight: "700",
    color: "#9ca3af",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    marginBottom: "5px",
  },

  cardTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#111827",
    margin: 0,
    letterSpacing: "-0.01em",
  },

  cardDesc: {
    fontSize: "13px",
    color: "#6b7280",
    lineHeight: "1.65",
    margin: "6px 0 0 0",
    fontWeight: "400",
  },

  featureList: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "8px 14px",
    padding: "13px",
    backgroundColor: "#fafafa",
    borderRadius: "8px",
    border: "1px solid #f3f4f6",
  },

  featureItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "12px",
    color: "#4b5563",
    fontWeight: "500",
  },

  featureCheck: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    backgroundColor: "#ecfdf5",
    color: "#059669",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "10px",
    fontWeight: "700",
    flexShrink: 0,
  },

  cardFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: "18px",
    borderTop: "1px solid #f3f4f6",
    marginTop: "auto",
  },

  footerHint: {
    fontSize: "11px",
    color: "#d1d5db",
    fontWeight: "400",
  },

  action: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontSize: "12px",
    fontWeight: "700",
    whiteSpace: "nowrap",
  },

  arrow: {
    fontSize: "14px",
  },

};